import * as React from 'react';
import {useState} from 'react';
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogContentText,
    TextField,
    Input,
    Button,
    FormControlLabel,
    FormGroup,
    Checkbox,
    Alert,
    Snackbar
    } from "@mui/material";
import {makeApiCall} from "../../hooks/CancellableApiCall";
import SettingsIcon from '@mui/icons-material/Settings';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from "dayjs";

interface EditEventFormProps {
    id: number,
    date: string,
    length: number,
    description: string,
    private: boolean,
    status: string
}

type alertType = "success" | "error" | "info"

export default function EditEventForm(props: EditEventFormProps) {
    const [open, setOpen] = useState(false);
    const [date, setDate] = useState(dayjs(props.date))
    const [eventLength, setEventLength] = useState(props.length)
    const [eventDesc, setEventDesc] = useState(props.description)
    const [eventPrivate, setEventPrivate] = useState(props.private)
    const [showAlert, setShowAlert] = useState(false)
    const [alertType, setAlertType] = useState<alertType>("success")
    const [alertText, setAlertText] = useState("")

    const setAlert = (type: alertType, text: string) => {
        setAlertType(type)
        setAlertText(text)
        setShowAlert(true)
    }

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <React.Fragment>
            <Button size="medium" sx={{maxWidth: "120px", float: "right", ml: 1}} color="warning" variant="contained" onClick={() => setOpen(true)}> Settings <SettingsIcon /></Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Edit Event</DialogTitle>
            <DialogContent>
                <DialogContentText>Date and Time</DialogContentText>
                <DateTimePicker
                    defaultValue={date}
                    disablePast
                    format="DD/MM/YYYY HH:mm"
                    onChange={(event) => {setDate(event!!)}}
                />
            </DialogContent>
            <DialogContent sx={{ width: 400 }}>
                <DialogContentText>Event Description</DialogContentText>
                <TextField multiline rows={4} fullWidth placeholder="Enter here..."
                       value={eventDesc}
                       onChange={(event) => setEventDesc(event.target.value)}/>
            </DialogContent>
            <DialogContent>
                <DialogContentText>Event Length (Minutes)</DialogContentText>
                <Input
                       value={eventLength / 60}
                       type={"number"}
                       onChange={(event) => {
                           let number = Number(event.target.value)
                           if (number < 1) {
                               setEventLength(1 * 60)
                           } else if (number > 240) {
                               setEventLength(240 * 60)
                           } else {
                               setEventLength(number * 60)
                           }
                       }}/>
            </DialogContent>
                        <DialogContent>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox
                                    checked={eventPrivate}
                                    onChange={(event) => setEventPrivate(event.target.checked)}
                                />} label="Private Event" />
                            </FormGroup>
                        </DialogContent>
                <DialogContent>
                    <Button color={"info"} onClick={() => handleClose()}>Close</Button>
                    <Button color={"success"} onClick={() => {
                              makeApiCall({
                                  url: `/api/event/${props.id}`,
                                  method: "PATCH",
                                  body: {
                                      eventId: props.id,
                                      newDate: date,
                                      newLength: eventLength,
                                      newDescription: eventDesc,
                                      newPrivate: eventPrivate
                                  },
                                  onLoadedCallback: () => {
                                      window.location.reload()
                                  },
                                  onError: () => {
                                      setAlert("error", "Failed to edit event")
                                      handleClose()
                                  }
                              })
                    }}>Edit</Button>
                </DialogContent>
            </Dialog>
            <Snackbar open={showAlert} autoHideDuration={5000} onClose={() => setShowAlert(false)}>
                <Alert severity={alertType} onClose={() => setShowAlert(false)} sx={{width: "100%"}} variant="filled">
                    {alertText}
                </Alert>
            </Snackbar>
        </React.Fragment>
    );
}